'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text) {
  if (!text) {
    return null;
  }

  var possibleScreenName = text.match(_validReply2.default);
  if (!possibleScreenName || RegExp.rightContext.match(_endMentionMatch2.default)) {
    return null;
  }

  return possibleScreenName[1];
};

var _endMentionMatch = require('./regexp/endMentionMatch');

var _endMentionMatch2 = _interopRequireDefault(_endMentionMatch);

var _validReply = require('./regexp/validReply');

var _validReply2 = _interopRequireDefault(_validReply);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default']; // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0